var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWormyapple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 493.29 408.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a7830;}.cls-2{fill:#642e0c;}.cls-3{fill:none;stroke:#f59db2;stroke-linecap:round;stroke-linejoin:round;stroke-width:60px;}.cls-4{fill:#c1d5d7;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#f59db2;}.cls-7{fill:#231f20;}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 111.8,
    y1: 329.61,
    x2: 473,
    y2: 329.61,
    gradientTransform: "translate(0.18 -0.17) rotate(0.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#cd6a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cb653b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ba3f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#b4303f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.88,158.39c-28,14.91-67.2-3.9-67.2-3.9s6.3-43,34.33-57.9,67.2,3.9,67.2,3.9S356.92,143.48,328.88,158.39Z",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.82,205.94S231.63,104.06,255,93.31l22.89,2.59s-14.33,76.71-12.6,108.61-7.5,1.43-7.5,1.43",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.5,439.5s-41.57-107.13-133.29-88.57",
    transform: "translate(-33.21 -90.84)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-54,428",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.65,199.33c17.09,4.16,55.6-26.25,94.92-35.43,38.43-9,86.21-3.34,112.51,35.56,28.45,42.08-18.11,163.87-39.45,212.91-21.72,49.94-31.23,81.48-70.55,81.46s-56.94-9.24-69.14-9.25-38.6,13.24-58.31,14.43c-21.69,1.3-51.51-15.81-65-51.31s-38-119.63-40.59-138-17.57-85.45-2.64-117c8.84-18.66,25.78-32.85,59.85-29.06C207.51,166.89,235,194.06,256.65,199.33Z",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.73,315.64s-82-6.52-92.52-81.85",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143,344l25,9,11-14,3.38-25.7L180,299l-2.28-11.77-2.51-5.74S179,283,148,284Z",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.09,270.14a39.44,39.44,0,0,1,8.59,8.85,54.1,54.1,0,0,1,6.12,10.89,58,58,0,0,1,4.52,24.81l-.07,1.6-.15,1.59c-.12,1.05-.15,2.12-.34,3.16l-.54,3.14c-.21,1-.46,2.06-.72,3.09l-.38,1.53-.48,1.51c-.31,1-.63,2-1,3a58.94,58.94,0,0,1-2.48,5.77,59.65,59.65,0,0,1-14.93,19.47c2.84-7.68,5.61-14.94,7.58-22.27.27-.91.53-1.81.71-2.74l.67-2.73.54-2.75.28-1.37.2-1.37c.12-.92.31-1.83.43-2.74l.3-2.75c.14-.92.16-1.84.24-2.75l.11-1.38,0-1.37a86.74,86.74,0,0,0-2-22.05A114.89,114.89,0,0,0,168.09,270.14Z",
    transform: "translate(-33.21 -90.84)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 33.29,
    cy: 142.66,
    rx: 6.5,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 10.29,
    cy: 143.66,
    rx: 6.5,
    ry: 11.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 8.79,
    cy: 144.16,
    rx: 4,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 31.79,
    cy: 143.16,
    rx: 4,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 11.79,
    cy: 140.16,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 34.79,
    cy: 139.16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47,254.77a14.29,14.29,0,0,1,5.15-2,19.52,19.52,0,0,1,5-.34,19.17,19.17,0,0,1,5,1A14.34,14.34,0,0,1,67,256a14.14,14.14,0,0,1-5.15,2,19.08,19.08,0,0,1-5,.33,20.05,20.05,0,0,1-5-1A14.79,14.79,0,0,1,47,254.77Z",
    transform: "translate(-33.21 -90.84)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWormyapple);
export default __webpack_public_path__ + "static/media/wormy apple.c392b628.svg";
export { ForwardRef as ReactComponent };